export const DEFAULT_YEARS_AHEAD = 15;
export const DEFAULT_PAST_START_DATE = new Date("1900-01-01");
export const DEFAULT_START_DATE = new Date("2000-01-01");
export const DEFAULT_TIME = "09:00";
export const DEFAULT_TIME_12HR = "09:00 AM";
export const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const HEALTH_PROFILE_URL = "/profile/health-profile";
export const PAGE_SIZE = 10;
export const MAATRA_VIDEO_URL = "https://www.youtube.com/watch?v=ZZdYMDAAkxo";
export const MAATRA_DASHBOARD_VIDEO_URL =
  "https://www.youtube.com/watch?v=4Rkwfrtv4jQ";

// S3 filenames (signed via /app-assets/video-signed-url, served from the
// maatra-assets bucket). Update the filename here once each clip is uploaded.
export const VIDEO_REMINDER_S3_FILE = "reminder.mp4";
export const VIDEO_LAB_TRENDS_S3_FILE = "lab-trends.mp4";
export const VIDEO_DOCUMENTS_S3_FILE = "documents.mp4";
export const VIDEO_HEALTH_SUMMARY_S3_FILE = "health-summary.mp4";
export const VIDEO_FAMILY_TAB_S3_FILE = "family-tab.mp4";
export const VIDEO_EMERGENCY_CARD_S3_FILE = "emergency-card.mp4";
export const VIDEO_SEARCH_S3_FILE = "search.mp4";
export const VIDEO_VITALS_S3_FILE = "vitals.mp4";

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB in bytes
